import type { VueComponentPropsBase } from '@/types';

/**
 * Le type de panneau permet de définir la taille requise de l'icône de chargement
 */
type LoadingIconSize = 'smaller' | 'default' | 'modal';

type ElLoadingPanelClasses = 'animateLoading';

type Props = Partial<VueComponentPropsBase<ElLoadingPanelClasses>> & {
  /** Libellé optionnel affiché après x nombre de millisecondes. */
  label: string;
  /** Délai en millisecondes avant que le texte ne s'affiche, lorsqu'il est défini. */
  labelRenderingDelay: number;
  /** type de composante pour le chargement:  De sa valeur dépendra entre autres la taille de l'icône. */
  iconSize?: LoadingIconSize;
  /**
   * Couleur appliquée sur l'icône de chargement.  Les valeurs pré-établies respectent la couleur pré-établie dans le
   * guide de styles alors qu'une valeur arbitraire de type `string` est appliquée tel quel.
   */
  iconColor?: 'white' | 'blue';
  /**
   * Position horizontal du spinner
   */
  justify?: 'left' | 'center' | 'right';
  /**
   * Position vertical du spinner
   */
  align?: 'top' | 'center' | 'bottom';
};

/** Taille en pixels de l'icône de chargement en fonction du type d'emplacement désigné */
const loadingTypeToSpinnerSizeMap: Record<LoadingIconSize, number> = {
  smaller: 40,
  default: 62,
  modal: 62,
};

export {
  loadingTypeToSpinnerSizeMap,
  type Props,
  type LoadingIconSize,
};
